// filter options which can be used with text search
const userFilters = ["username", "firstname", "lastname", "company"];

export default userFilters;
